import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { adminApi } from "../util/adminApi";

const AccessContext = createContext({ access: null, loading: true, can: () => false, reload: () => {} });

export const AccessProvider = ({ children }) => {
  const { profile } = useSelector((state) => state.userReducer);
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      setAccess(await adminApi.me());
    } catch {
      setAccess({ isOwner: false, roleName: "No access", permissions: {} });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (profile) reload();
  }, [profile, reload]);

  const can = useCallback(
    (module, action = "view") => !!access && (access.isOwner || (access.permissions?.[module] || []).includes(action)),
    [access]
  );

  return <AccessContext.Provider value={{ access, loading, can, reload }}>{children}</AccessContext.Provider>;
};

export const useAccess = () => useContext(AccessContext);
